import { render, staticRenderFns } from "./ReportAndHideProjectCommentModal.vue?vue&type=template&id=27773878&"
import script from "./ReportAndHideProjectCommentModal.vue?vue&type=script&lang=js&"
export * from "./ReportAndHideProjectCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports